import Multiselect from 'multiselect-react-dropdown';
import React, { useEffect, useState } from 'react';
import MainMenuBtn from '../menu-settings/main-menu-btn';
import SideBar from '../side-bar/side-bar';
import { useHistory } from 'react-router-dom'
import ProviderModel from '../../data/provider-model';
import PromotionsModel from '../../data/promotions-model';
import { toast } from 'react-toastify';
import ItemModel from '../../data/item-model';
import { useLocation } from 'react-router-dom'
import { getTranslatedText } from '../../helpers/checkTranslations';
import { store } from '../../redux/store';

const AddCoupons = () => {

    const [coupon, setCoupon] = useState({
        start: null,
        email: null,
        end: null,
        maxValue: 0,
        value: 0,
        percentage: 0,
        minValue: 0,
        times: null,
        title: null,
        description: null,
        userId: 'test',
        groupId: null,
        venueIds: [],
        itemIds: [],
        ownerId: 'HCN',
    });

    const [initialItems, setInitialItems] = useState([]);
    const [items, setItems] = useState([]);

    const [initialVenues, setInitialVenues] = useState([]);
    const [venues, setVenues] = useState([]);
    const [groups, setGroups] = useState(null);
    const [group, setGroup] = useState(null);

    const location = useLocation();
    const title = location.state?.title;
    const clone = location.state?.clone;
    const couponItem = location.state?.couponClone;

    useEffect(() => {
        couponItem && title && setCoupon(couponItem)
        couponItem && title && setInitialVenues(couponItem.venueIds)
        couponItem && title && setInitialItems(couponItem.itemIds && couponItem.itemIds.map(item => ({ id: item.id, name: item.providerName + ': ' + item.name, providerId: item.providerId })))
        couponItem && title && setGroup(couponItem.groupId ? couponItem.groupId : null)

        ProviderModel.getProviderGroups()
            .then(res => {
                setGroups(['', ...res])
            })
            .catch(err => {
                toast(err.message);
            });
    }, [])

    useEffect(() => {
        if (groups) {
            couponItem && couponItem.groupId && title || groups && groups.length > 0 ? setGroup(Object.assign(...groups.filter(g => g.id === couponItem?.groupId?.id))) : setGroup(null)
        }
    }, [groups])

    useEffect(() => {
        if (group) {
            group && group.providers && setVenues(group.providers?.reduce((acc, curr) => [...acc, ...curr], []))
            !group && setInitialVenues([])
        }
    }, [group])

    useEffect(() => {
        let allItems = []
        initialVenues &&
            initialVenues.length > 0
            ? initialVenues.map(v =>
                ItemModel.getRootCategoryItems(v.id)
                    .then(res => {
                        res && res.length > 0 && allItems.push(...res)
                        setItems(allItems.map(item => ({ id: item.id, name: item.providerName + ': ' + item.name, providerId: item.providerId })))
                    })
                    .catch(err => toast(err.message)),
            )
            : setItems([])
    }, [initialVenues, venues])

    const history = useHistory()

    const cancelAction = () => {
        history.push('/coupons-info')
    };
    const onSaveCoupon = () => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!coupon.title) {
            toast(getTranslatedText('titleWarning', store))
        } else if (coupon.email && !re.test(coupon.email)) {
            toast(getTranslatedText('validemailWarning', store))
        } else if (Number(coupon.value) < 1 && Number(coupon.percentage) < 1) {
            toast(getTranslatedText('valuePercentageWarning', store))
        } else if (coupon.start && coupon.end && new Date(coupon.start).getTime() > new Date(coupon.end).getTime()) {
            toast(getTranslatedText('validDatesWarning', store))
        } else {
            let couponITEM = {
                title: coupon.title,
                times: coupon.times ? coupon.times : 0,
                ...coupon.id && !clone && { id: coupon.id },
                start: coupon.start ? coupon.start : null,
                end: coupon.end ? coupon.end : null,
                maxValue: coupon.maxValue ? coupon.maxValue : 0,
                value: coupon.value ? coupon.value : 0,
                percentage: coupon.percentage ? coupon.percentage : 0,
                minValue: coupon.minValue ? coupon.minValue : 0,
                email: coupon.email ? coupon.email : null,
                description: coupon.description ? coupon.description : null,
                userId: coupon.userId ? coupon.userId : null,
                groupId: group ? group.id : coupon.groupId ? coupon.groupId : null,
                venueIds: initialVenues && initialVenues.length > 0 ? initialVenues?.map(i => i.id) : [],
                itemIds: initialItems && initialItems.length > 0 ? initialItems?.map(i => i.id) : [],
                ownerId: coupon.ownerId ? coupon.ownerId : null,
            }

            if (couponItem && !clone) {
                PromotionsModel.remote_editOne(couponITEM)
                history.push('coupons-info')
                setCoupon(null)
            } else if (!couponItem && !clone) {
                PromotionsModel.remote_addOne(couponITEM)
                history.push('coupons-info')
                setCoupon(null)
            }

            if (clone && couponITEM.title !== title) {
                PromotionsModel.remote_addOne(couponITEM)
                history.push('coupons-info')
                setCoupon(null)
            } else if (clone && couponITEM.title === title) {
                toast(getTranslatedText('differentNameWarning', store))
            }
        }
    };

    const onSelectVenue = (list) => {
        setInitialVenues(list)
        setCoupon({ ...coupon, venueIds: list.map(x => x.id) })
    };

    const onRemoveVenue = (list, item) => {

        setInitialVenues(list.filter(l => l.id !== item.id))
        setInitialItems(initialItems.filter(l => l.providerId !== item.id))
        setItems(items.filter(i => i.providerId !== item.id))

    };

    const onSelectItem = (list) => {

        setInitialItems(list)
        setCoupon({ ...coupon, itemIds: list.map(x => x.id) })
    };

    const onRemoveItem = (list, item) => {
        setInitialItems(list.filter(l => l.id !== item.id))
    };

    const onCheckAll = ({ target: { checked } }) => {
        if (checked) {
            setInitialVenues(venues)
            setInitialItems([])
        } else {
            setInitialVenues([])
            setInitialItems([])
        }
    };

    return (
        <div className="provider-info">
            <div className="divider grid-flex">
                <SideBar />
                <div id="page" className="site" style={{ padding: 0 }}>
                    <div className="main-content">
                        <header className='site-header'>
                            <div className="flex-between">
                                <h1 className="main-title">
                                    {title ? getTranslatedText('edit', store) : getTranslatedText('add', store)} {getTranslatedText('coupon', store)}
                                </h1>
                                <div className="side-functionality">
                                    <div className="side-button grid-flex">
                                        <button onClick={cancelAction} type='button' className="btn">
                                            {getTranslatedText('cancel', store)}
                                        </button>
                                        <button onClick={onSaveCoupon} type='submit' className="btn default-btn">
                                            {getTranslatedText('save', store)}
                                        </button>
                                        <MainMenuBtn />
                                    </div>
                                </div>
                            </div>
                        </header>
                        <main className="spacing">
                            <div id="content_rest_info" className="inner-content">
                                <div className="info info-title">
                                    <label>
                                        {getTranslatedText('couponName', store)}
                                        <sup>*</sup>
                                    </label>
                                    <input
                                        value={coupon.title}
                                        onChange={({ target: { value } }) => setCoupon({ ...coupon, title: value })}
                                        id="coupon_name"
                                        name="coupon_name"
                                        type="text"
                                    />
                                </div>
                                <div className="info info-title">
                                    <label>
                                        {getTranslatedText('description', store)}
                                    </label>
                                    <input
                                        value={coupon.description}
                                        onChange={({ target: { value } }) => setCoupon({ ...coupon, description: value })}
                                        id="coupon_description"
                                        name="coupon_description"
                                        type="text"
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 50 }}>

                                    <div className="info info-title">
                                        <label>
                                            {getTranslatedText('startDate', store)}
                                        </label>
                                        <span className="custom-input-date margin-top">
                                            <input
                                                type="date"
                                                id="event-date"
                                                className="margin-top-half"
                                                name="event-date"
                                                value={coupon.start && coupon.start.split('T')?.[0]}
                                                onChange={({ target: { value } }) => setCoupon({ ...coupon, start: value })}

                                            />
                                            <span className="date-icon">
                                                <svg width="30" height="30" viewBox="0 0 30 30" style={{ marginLeft: -4 }}
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd"
                                                        d="M25.5 4.5H24V1.5C24 0.671573 23.3284 0 22.5 0C21.6716 0 21 0.671573 21 1.5V4.5H9V1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5V4.5H4.5C2.01472 4.5 0 6.51472 0 9V25.5C0 27.9853 2.01472 30 4.5 30H25.5C27.9853 30 30 27.9853 30 25.5V9C30 6.51472 27.9853 4.5 25.5 4.5ZM3 9C3 8.17157 3.67157 7.5 4.5 7.5H25.5C26.3284 7.5 27 8.17157 27 9V10.5H3V9ZM25.5 27C26.3284 27 27 26.3284 27 25.5V13.5H3V25.5C3 26.3284 3.67157 27 4.5 27H25.5Z"
                                                        fill="white" />
                                                </svg>
                                            </span>
                                            <span className="arrow-icon arrow down"></span>
                                        </span>
                                    </div>
                                    <div style={{ marginLeft: 60 }} className="info info-title">
                                        <label>
                                            {getTranslatedText('endDate', store)}
                                        </label>
                                        <span className="custom-input-date margin-top">
                                            <input
                                                type="date"
                                                id="event-date"
                                                className="margin-top-half"
                                                name="event-date"
                                                value={coupon.end && coupon.end.split('T')?.[0]}
                                                onChange={({ target: { value } }) => setCoupon({ ...coupon, end: value })}

                                            />
                                            <span className="date-icon">
                                                <svg width="30" height="30" viewBox="0 0 30 30" style={{ marginLeft: -4 }}
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd"
                                                        d="M25.5 4.5H24V1.5C24 0.671573 23.3284 0 22.5 0C21.6716 0 21 0.671573 21 1.5V4.5H9V1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5V4.5H4.5C2.01472 4.5 0 6.51472 0 9V25.5C0 27.9853 2.01472 30 4.5 30H25.5C27.9853 30 30 27.9853 30 25.5V9C30 6.51472 27.9853 4.5 25.5 4.5ZM3 9C3 8.17157 3.67157 7.5 4.5 7.5H25.5C26.3284 7.5 27 8.17157 27 9V10.5H3V9ZM25.5 27C26.3284 27 27 26.3284 27 25.5V13.5H3V25.5C3 26.3284 3.67157 27 4.5 27H25.5Z"
                                                        fill="white" />
                                                </svg>
                                            </span>
                                            <span className="arrow-icon arrow down"></span>
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 50 }}>
                                    <div style={{ width: 100 }} className="info info-title">
                                        <label>
                                            {getTranslatedText('value', store)}
                                        </label>
                                        <input
                                            disabled={coupon.percentage > 0 || coupon.maxValue > 0}
                                            id="searchBar"
                                            style={{ width: 60, textAlign: 'start', cursor: coupon.percentage > 0 && 'not-allowed', backgroundColor: (coupon.percentage > 0 || coupon.maxValue > 0) && '#808080' }}
                                            value={Math.abs(coupon.value) === 0 ? '' : Math.abs(coupon.value)}
                                            onChange={({ target: { value } }) => Number(value) < 0 ? 0 : setCoupon({ ...coupon, value: Number(value) })}
                                            name="coupon_value"
                                            type="number"
                                            min={0}
                                        />
                                    </div>
                                    <div class="tooltip" style={{ marginTop: 40, marginLeft: 40, marginRight: 30 }}>
                                        <div style={{ display: 'flex' }}>
                                            <span>
                                                {getTranslatedText('or', store)}
                                                <sup>*</sup>
                                            </span>
                                            <div class="tooltiptext">
                                                <span>
                                                    {getTranslatedText('valueOrPercentage', store)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ width: 170 }} className="info info-title">
                                        <label>
                                            {getTranslatedText('PERCENTAGE', store)}
                                        </label>
                                        <input
                                            disabled={coupon.value > 0}
                                            id="searchBar"
                                            style={{ width: 60, textAlign: 'start', cursor: coupon.value > 0 && 'not-allowed', backgroundColor: coupon.value > 0 && '#808080' }}
                                            value={Math.abs(coupon.percentage) === 0 ? '' : Math.abs(coupon.percentage)}
                                            onChange={({ target: { value } }) => Number(value) < 0 ? 0 : setCoupon({ ...coupon, percentage: value > 100 ? 100 : Number(value) })}
                                            type="number"
                                            min={0}
                                            max={100}
                                        />
                                    </div>
                                    <div style={{ width: 170 }} className="info info-title">
                                        <label>
                                            {getTranslatedText('maxValue', store)}
                                        </label>
                                        <input
                                            disabled={coupon.value > 0}
                                            id="searchBar"
                                            style={{ width: 60, textAlign: 'start', cursor: coupon.value > 0 && 'not-allowed', backgroundColor: coupon.value > 0 && '#808080' }}
                                            value={Math.abs(coupon.maxValue) === 0 ? '' : Math.abs(coupon.maxValue)}
                                            onChange={({ target: { value } }) => Number(value) < 0 ? 0 : setCoupon({ ...coupon, maxValue: Number(value) })}
                                            name="coupon_maxValue"
                                            type="number"
                                            min={0}
                                        />
                                    </div>
                                    <div style={{ width: 170 }} className="info info-title">
                                        <label>
                                            {getTranslatedText('minOrder', store)}
                                        </label>
                                        <input
                                            id="searchBar"
                                            style={{ width: 60, textAlign: 'center' }}
                                            value={Math.abs(coupon.minValue) === 0 ? '' : Math.abs(coupon.minValue)}
                                            onChange={({ target: { value } }) => Number(value) < 0 ? 0 : setCoupon({ ...coupon, minValue: Number(value) })}
                                            name="coupon_minValue"
                                            type="number"
                                            min={0}
                                        />
                                    </div>
                                    <div style={{ width: 170 }} className="info info-title">
                                        <label>
                                            {getTranslatedText('count', store)}
                                        </label>
                                        <input
                                            id="searchBar"
                                            style={{ width: 60, textAlign: 'center' }}
                                            value={Math.abs(coupon.times) === 0 ? '' : Math.abs(coupon.times)}
                                            onChange={({ target: { value } }) => Number(value) < 0 ? 0 : setCoupon({ ...coupon, times: parseInt(value) })}
                                            name="coupon_times"
                                            type="number"
                                            min={0}
                                        />
                                    </div>
                                </div>
                                <div className="info info-title">
                                    <label>
                                        {getTranslatedText('email', store)}
                                    </label>
                                    <input
                                        value={coupon.email}
                                        onChange={({ target: { value } }) => {
                                            setCoupon({ ...coupon, email: value })
                                        }}
                                        id="coupon_email"
                                        name="coupon_email"
                                        type="text"
                                    />
                                </div>

                                <h2>
                                    {getTranslatedText('restrictions', store)}
                                </h2>

                                {!group?.id
                                    ? <div className="info" style={{ marginTop: 50 }}>
                                        <label htmlFor="provider_timezone">
                                            {getTranslatedText('group', store)}
                                        </label>
                                        <select
                                            defaultValue={group?.name}
                                            onChange={({ target: { value } }) => {
                                                setGroup(...groups.filter(g => g.id === value))
                                            }}
                                        >
                                            {groups && groups.length > 0 && groups.map(g => <option value={g.id}>{g.name}</option>)}
                                        </select>
                                    </div>
                                    : <div style={{ display: 'flex', marginTop: 50 }}>
                                        <span>{getTranslatedText('group', store)}: {group.name}</span>
                                        <svg width="25"
                                            height="25"
                                            style={{ marginLeft: 12, marginTop: -4, cursor: 'pointer' }}
                                            viewBox="0 0 29 29"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            onClick={() => {
                                                setGroup(null)
                                                setCoupon({ ...coupon, groupId: null })
                                                setItems([])
                                                setInitialItems([])
                                                setVenues([])
                                                setInitialVenues([])
                                            }}
                                        >
                                            <path d="M27.3356 4.33917H2.07271C1.70054 4.33917 1.34361 4.49153 1.08044 4.76273C0.817278 5.03393 0.669434 5.40175 0.669434 5.78528C0.669434 6.16881 0.817278 6.53663 1.08044 6.80783C1.34361 7.07903 1.70054 7.23139 2.07271 7.23139H4.87992V24.5874C4.87992 25.7382 5.32352 26.8418 6.11314 27.6555C6.90276 28.4693 7.97371 28.9264 9.0904 28.9264H20.3179C21.4346 28.9264 22.5056 28.4693 23.2952 27.6555C24.0848 26.8418 24.5284 25.7382 24.5284 24.5874V7.23139H27.3356C27.7078 7.23139 28.0647 7.07903 28.3279 6.80783C28.591 6.53663 28.7389 6.16881 28.7389 5.78528C28.7389 5.40175 28.591 5.03393 28.3279 4.76273C28.0647 4.49153 27.7078 4.33917 27.3356 4.33917ZM13.3009 20.2484C13.3049 20.441 13.2716 20.6325 13.2029 20.8116C13.1342 20.9907 13.0314 21.1539 12.9007 21.2916C12.77 21.4293 12.6139 21.5387 12.4416 21.6133C12.2693 21.688 12.0842 21.7265 11.8973 21.7265C11.7104 21.7265 11.5253 21.688 11.353 21.6133C11.1807 21.5387 11.0246 21.4293 10.8939 21.2916C10.7631 21.1539 10.6604 20.9907 10.5917 20.8116C10.5229 20.6325 10.4896 20.441 10.4937 20.2484V13.0172C10.4896 12.8246 10.5229 12.6331 10.5917 12.454C10.6604 12.2748 10.7631 12.1116 10.8939 11.974C11.0246 11.8363 11.1807 11.7269 11.353 11.6522C11.5253 11.5775 11.7104 11.5391 11.8973 11.5391C12.0842 11.5391 12.2693 11.5775 12.4416 11.6522C12.6139 11.7269 12.77 11.8363 12.9007 11.974C13.0314 12.1116 13.1342 12.2748 13.2029 12.454C13.2716 12.6331 13.3049 12.8246 13.3009 13.0172V20.2484ZM18.9146 20.2484C18.9187 20.441 18.8854 20.6325 18.8167 20.8116C18.7479 20.9907 18.6452 21.1539 18.5145 21.2916C18.3837 21.4293 18.2276 21.5387 18.0553 21.6133C17.883 21.688 17.698 21.7265 17.511 21.7265C17.3241 21.7265 17.1391 21.688 16.9668 21.6133C16.7945 21.5387 16.6384 21.4293 16.5076 21.2916C16.3769 21.1539 16.2741 20.9907 16.2054 20.8116C16.1367 20.6325 16.1034 20.441 16.1074 20.2484V13.0172C16.1034 12.8246 16.1367 12.6331 16.2054 12.454C16.2741 12.2748 16.3769 12.1116 16.5076 11.974C16.6384 11.8363 16.7945 11.7269 16.9668 11.6522C17.1391 11.5775 17.3241 11.5391 17.511 11.5391C17.698 11.5391 17.883 11.5775 18.0553 11.6522C18.2276 11.7269 18.3837 11.8363 18.5145 11.974C18.6452 12.1116 18.7479 12.2748 18.8167 12.454C18.8854 12.6331 18.9187 12.8246 18.9146 13.0172V20.2484Z" fill="white" />
                                            <path d="M11.8964 2.89215H17.5109C17.8831 2.89215 18.24 2.7398 18.5032 2.46861C18.7663 2.19741 18.9142 1.8296 18.9142 1.44608C18.9142 1.06255 18.7663 0.694737 18.5032 0.423546C18.24 0.152354 17.8831 8.08214e-09 17.5109 0H11.8964C11.5243 8.08214e-09 11.1673 0.152354 10.9042 0.423546C10.641 0.694737 10.4932 1.06255 10.4932 1.44608C10.4932 1.8296 10.641 2.19741 10.9042 2.46861C11.1673 2.7398 11.5243 2.89215 11.8964 2.89215Z" fill="white" />
                                        </svg>

                                    </div>
                                }

                                <div className="info" style={{ marginTop: 50 }}>
                                    <label htmlFor="provider_timezone">
                                        {getTranslatedText('venue', store)}
                                        {group && group.name && <div class="tooltip">
                                            <div style={{ display: 'flex' }}>
                                                <input
                                                    type='checkbox'
                                                    defaultChecked={false}
                                                    checked={initialVenues?.length === venues?.length}
                                                    onChange={onCheckAll}
                                                />
                                                <div class="tooltiptext">
                                                    <span>
                                                        {getTranslatedText('selectAllProviders', store)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>}
                                    </label>
                                    <Multiselect
                                        options={venues}
                                        onSelect={onSelectVenue}
                                        onRemove={onRemoveVenue}
                                        displayValue="name"
                                        placeholder={coupon.venueIds?.length === 0 ? 'Select' : ''}
                                        selectedValues={initialVenues}
                                        emptyRecordMsg={group && group.name ? 'No more data' : 'You have to select a group first'}

                                    />
                                </div>

                                <div className="info">
                                    <label htmlFor="provider_timezone">
                                        {getTranslatedText('item', store)}
                                    </label>
                                    <Multiselect
                                        options={items}
                                        onSelect={onSelectItem}
                                        onRemove={onRemoveItem}
                                        displayValue="name"
                                        placeholder={coupon.itemIds?.length === 0 ? 'Select' : ''}
                                        selectedValues={initialItems}
                                        emptyRecordMsg={group && venues && venues.length > 0 && items.length === 0
                                            ? 'Choose a venue first'
                                            : group && venues && venues.length > 0 && items.length > 0
                                                ? 'No more data'
                                                : 'You have to select a group first'
                                        }
                                    />
                                </div>


                                <div style={{ marginBottom: 280 }} className="info info-title">
                                    <label>
                                        {getTranslatedText('owner', store)}
                                        <sup>*</sup>
                                    </label>
                                    <select
                                        id="provider_type"
                                        name="coupon_owner"
                                        value={coupon.ownerId}
                                        onChange={event => {
                                            setCoupon({ ...coupon, ownerId: event.target.value })
                                        }}
                                    >
                                        <option disabled defaultValue></option>
                                        <option value="0">HCN</option>
                                    </select>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddCoupons